import { render, staticRenderFns } from "./OtherMessageComponent.vue?vue&type=template&id=0929da4a&"
import script from "./OtherMessageComponent.vue?vue&type=script&lang=js&"
export * from "./OtherMessageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports